

/**
 * @name NewProfilePhotoController
 * @description Controller for profile photos
 * @param {Unknown} _ Lodash
 * @param {Unknown} $log Angular log service
 * @param {Unknown} $uibModal Bootstrap modal service
 * @param {Unknown} InkImage The InkImage service
 * @param {Unknown} AlertMessages The Alert Messages service
 * @param {Unknown} RESPONSE_MESSAGES The Response Messages constant
 * @param {object} Session The Session service
 * @param {object} $rootScope The Angular $rootScope service
 * @param {object} $scope The Angular $scope service
 */
function ProfilePhotoController(
  _,
  $log,
  $uibModal,
  InkImage,
  AlertMessages,
  RESPONSE_MESSAGES,
  Session,
  $rootScope,
  $scope
) {
  let vm = this;
  vm.$onInit = function() {
    vm.openCropModal = openCropModal;
    vm.toggleDropdown = toggleDropdown;
    vm.remove = remove;
    vm.newImageFile = '';
    vm.size = _.isUndefined(vm.size) ? 'large' : vm.size;
    vm.type = _.isUndefined(vm.type) ? 'collector' : vm.type;
    vm.showName = _.isUndefined(vm.showName) ? true : vm.showName;
    vm.status = {
      isopen: false
    };
  };

  vm.$onChanges = function(updates) {
    if (!_.isUndefined(updates.imageId) &&
    !_.isUndefined(updates.imageId.currentValue) &&
    updates.imageId.currentValue !== null) {
      InkImage.get(_.isObject(updates.imageId.currentValue) ?
      updates.imageId.currentValue.id : updates.imageId.currentValue)
      .then(function(image) {
        vm.imageId = image.id;
        vm.image = image;
      });
    } else if (!_.isUndefined(updates.imageId) &&
    !_.isUndefined(updates.imageId.currentValue) &&
    updates.imageId.currentValue === null) {
      vm.imageId = null;
      vm.image = null;
    }
  };

  /**
   * @name toggleDropdown
   * @description Function to open/close the dropdown menu
   * @param {type} $event Description
   */
  function toggleDropdown($event) {
    $event.preventDefault();
    $event.stopPropagation();
    vm.status.isopen = !vm.status.isopen;
  }

  /**
   * @name openCropModal
   * @description Function to open the crop modal after selecting a new image
   * @param {unknown} image The image to pass to the modal
   */
  function openCropModal(image) {
    if (image !== null) {
      let modalInstance = $uibModal.open({
        component: 'inkImageCrop',
        animation: true,
        backdrop: 'static',
        resolve: {
          image: function() {
            return image;
          }
        }
      });
      modalInstance.result.then(function(newImage) {
        if (vm.imageId === null || _.isUndefined(vm.imageId)) {
          InkImage.add(newImage).then(function(savedImage) {
            vm.onChange({imageId: savedImage.id});
            vm.image = savedImage;
          });
        } else {
          InkImage.update(vm.imageId, newImage).then(function(savedImage) {
            vm.onChange({imageId: savedImage.id});
            vm.image = savedImage;
            $rootScope.$broadcast('refresh-image', savedImage.id, vm.type);
          });
        }
      }, function() {
        AlertMessages.add({
          msg: RESPONSE_MESSAGES.closedWithoutSaving,
          type: 'warning'
        });
      });
    }
  }

  /**
   * @name remove
   * @description Function to remove the profile image
   * @param {number} id The image to remove
   */
  function remove() {
    let file = '';
    InkImage.remove(vm.image.id, file).then(function(image) {
      vm.imageId = null;
      vm.image = null;
      vm.onChange({imageId: null});
    });
  }

  $scope.$on('refresh-image', function(event, imageId, type) {
    if (type === vm.type) {
      InkImage.get(imageId).then(function(image) {
        vm.imageId = image.id;
        vm.image = image;
      });
    }
  });
}

angular
  .module('inkfinder')
  .controller('ProfilePhotoController', ProfilePhotoController);



// WEBPACK FOOTER //
// ./components/collector/profile-photo/profile-photo.controller.js